import React from "react";
import { Typography } from "@mui/material";

export default function CompareCompanies() {
  return (
    <div>
      <Typography variant="h4">Compare Companies</Typography>
      <Typography>Feature coming soon...</Typography>
    </div>
  );
}
